import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const TextMaskCustom = forwardRef<HTMLInputElement, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
      />
    );
  }
);
TextMaskCustom.displayName = "TextMaskCustom";

const CepTextField = forwardRef<
  HTMLInputElement,
  Omit<TextFieldProps, "label" | "placeholder" | "InputProps">
>((props, ref) => {
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: TextMaskCustom as never,
        inputProps: {
          mask: "00.000-000",
        },
      }}
      color="primary"
      label="CEP *"
      placeholder="00.000-000"
      ref={ref}
      sx={{
        "& .MuiFormLabel-root": {
          color: "primary.main",
        },
        "& .MuiInputBase-input": {
          color: "primary.main",
        },
      }}
    />
  );
});
CepTextField.displayName = "CepTextField";
export default CepTextField;
